import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {withdrawalMember} from "../../api/memberApi";
import axios from "axios";
import {useLogoutHandle} from "../../hooks/logoutHandle";
import {alertAfterFunction, defaultAlert, defaultConfirm} from "../../utils/alert";


const MemberWithdrawal = () => {
    const reasonMap = [
        {key : "inconvenient", reason: "이용이 불편하고 장애가 많아서"},
        {key : "betterService", reason: "다른 비슷한 서비스가 더 좋아서"},
        {key : "lowUsage", reason: "사용빈도가 낮아서"},
        {key : "noContent", reason: "이용할 콘텐츠가 별로 없어서"},
        {key : "other", reason: ""}
    ]

    const navigate = useNavigate();

    const [reasonType, setReasonType] = useState<string>('inconvenient');
    const [otherReason, setOtherReason] = useState<string>('');
    const [agree, setAgree] = useState<boolean>(false);
    const [password, setPassword] = useState<string>('');

    const handleReasonChange = (value: string) => {
        setReasonType(value)
        if (value !== "other") setOtherReason('');
    };
    const handleChangeOtherReason = (value: string) => {
        setOtherReason(value);
    };
    const changeAgree = (value: boolean) => {
        setAgree(value);
    };
    const inputPassword = (value: string) => {
        setPassword(value);
    };
    const logoutHandle = useLogoutHandle();


    const handleWithdrawalMember = async () => {

        const map = reasonMap.find((item) => item.key === reasonType);
        const reason = reasonType !== "other" ? map?.reason : otherReason;

        if (!reason) {
            defaultAlert("사유를 선택 또는 입력해주세요.");
            return;
        }

        defaultConfirm("회원 탈퇴를 계속 진행하시겠습니까?", "탈퇴", "취소", async (confirm) => {
            if (confirm) {
                try {

                    const response = await withdrawalMember({
                        reason: reason,
                        password: password,
                        agreed: agree
                    });

                    if (response.data.code === "00") {
                        alertAfterFunction("탈퇴에 성공했습니다.", () => logoutHandle());
                    }
                } catch (error) {
                    console.log(error)
                    if (axios.isAxiosError(error)) {
                        const errorCode = error.response?.data?.code;
                        if (errorCode === "MW003") {
                            defaultConfirm(error.response?.data?.message ?? "보유 중인 WINPAY 잔액이 있습니다.\n회원탈퇴를 원하시면 보유잔액을 잔액환불 후\n회원 탈퇴를 진행해주세요.", "잔액환불하기", "취소", (confirm) => {
                                if (confirm) {
                                    navigate("/wallet/refund");
                                } else {
                                    return;
                                }
                            })
                        } else if (errorCode === "MW004") {
                            defaultConfirm(error.response?.data?.message ?? "보유 중인 정산금 잔액이 있습니다.\n회원탈퇴를 원하시면 보유잔액을 잔액환불 후\n회원 탈퇴를 진행해주세요.", "출금하기", "취소", (confirm) => {
                                if (confirm) {
                                    navigate("/settlement/withdrawal");
                                } else {
                                    return;
                                }
                            })
                        } else {
                            defaultAlert(error.response?.data?.message ?? "회원 탈퇴에 실패했습니다.");
                        }
                    } else {
                        defaultAlert("알 수 없는 오류가 발생했습니다.");
                    }
                }
            } else {
                return;
            }
        })
    };

    return (
        <>
            <div className="bottom-btn">
                <button type="button" className="btn cancel" onClick={() => navigate(-1)}>
                    이전
                </button>
                {(reasonType !== "other" ? true : otherReason) && agree && password && (
                    <button type="button" className="btn confirm" onClick={handleWithdrawalMember}>
                        회원 탈퇴
                    </button>
                )}
            </div>

            <main className="container type_gray">
                <section className="bg-white">
                    <div className="inner-bottom">
                        <div className="guide-box yellow">
                            <h5 className="point-tit">탈퇴 유의사항</h5>
                            <ul className="guidF-list">
                                <li>예약완료된 공고 또는 진행중인 공고가 있는 경우 탈퇴가 불가합니다.</li>
                                <li>보유한 WINPAY 잔액이 있는 경우 탈퇴가 불가합니다.</li>
                                <li>보유잔액이 500원 이하인 경우 환불이 어려우며 자동 소멸됩니다.(1만원 이하 환불 수수료 500원)</li>
                                <li>회원 탈퇴 시 모든 서비스가 종료되며, 거래 데이터가 삭제됩니다.</li>
                                <li>회원 탈퇴 시 7일동안 재가입이 불가하며 탈퇴한 ID로 다시 회원가입이 불가합니다.</li>
                            </ul>
                        </div>
                    </div>
                </section>

                <section className="tit-box-wrap bg-white pt30">
                    <h2 className="headline middle">
                        정말 떠나시는 건가요?<br/>한 번 더 생각해 보지 않으시겠어요?
                    </h2>
                    <p className="subtit">
                        회원 탈퇴를 하시려는 이유를 말씀해 주세요.<br/>서비스 개선에 중요 자요로 활용하겠습니다.
                    </p>
                </section>

                <form className="form-box">
                    <section className="bg-white no-gap">
                        <fieldset>
                            <legend>회원탈퇴 폼</legend>
                            <div className="inner-bottom">
                                <div className="form-item">
                                    <span className="circle-radio-box mt10">
                                        <input
                                            type="radio"
                                            id="rad1"
                                            name="secession"
                                            className="blind"
                                            value="inconvenient"
                                            checked={reasonType === 'inconvenient'}
                                            onChange={(e) => handleReasonChange(e.target.value)}
                                        />
                                        <label htmlFor="rad1">이용이 불편하고 장애가 많아서</label>
                                    </span>
                                    <span className="circle-radio-box mt10">
                                        <input
                                            type="radio"
                                            id="rad2"
                                            name="secession"
                                            className="blind"
                                            value="betterService"
                                            checked={reasonType === 'betterService'}
                                            onChange={(e) => handleReasonChange(e.target.value)}
                                        />
                                        <label htmlFor="rad2">다른 비슷한 서비스가 더 좋아서</label>
                                    </span>
                                    <span className="circle-radio-box mt10">
                                        <input
                                            type="radio"
                                            id="rad3"
                                            name="secession"
                                            className="blind"
                                            value="lowUsage"
                                            checked={reasonType === 'lowUsage'}
                                            onChange={(e) => handleReasonChange(e.target.value)}
                                        />
                                        <label htmlFor="rad3">사용빈도가 낮아서</label>
                                    </span>
                                    <span className="circle-radio-box mt10">
                                        <input
                                            type="radio"
                                            id="rad4"
                                            name="secession"
                                            className="blind"
                                            value="noContent"
                                            checked={reasonType === 'noContent'}
                                            onChange={(e) => handleReasonChange(e.target.value)}
                                        />
                                        <label htmlFor="rad4">이용할 콘텐츠가 별로 없어서</label>
                                    </span>
                                    <span className="circle-radio-box mt10">
                                        <input
                                            type="radio"
                                            id="rad5"
                                            name="secession"
                                            className="blind"
                                            value="other"
                                            checked={reasonType === 'other'}
                                            onChange={(e) => handleReasonChange(e.target.value)}
                                        />
                                        <label htmlFor="rad5">기타</label>
                                        <div className="input-box mt10">
                                            <input
                                                type="text"
                                                disabled={reasonType !== 'other'}
                                                value={otherReason}
                                                onChange={(e) => handleChangeOtherReason(e.target.value)}
                                            />
                                        </div>
                                    </span>
                                </div>

                                <div className="form-item">
                                    <label htmlFor="" className="input-tit">로그인 비밀번호 확인</label>
                                    <div className="input-box">
                                        <input
                                            type="password"
                                            placeholder="현재 비밀번호를 입력해주세요"
                                            value={password}
                                            onChange={(e) => inputPassword(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="form-item">
                                    <div className="default-checkbox">
                                        <input
                                            type="checkbox"
                                            id="chk1"
                                            name="chk1"
                                            className="input"
                                            checked={agree}
                                            onChange={(e) => changeAgree(e.target.checked)}
                                        />
                                        <label htmlFor="chk1">안내사항을 확인하였으며 동의합니다.</label>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </section>
                </form>
            </main>
        </>
    );
};

export default MemberWithdrawal;